import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Copy, CopyPlus, Scissors, Settings2, Trash2, Unlink, VolumeX, X } from 'lucide-react';
import { compatibleTrack } from '../../lib/creatorEditing';

export default function CreatorClipMenu({ context, found, project, time, canPaste, onAction, onClose }) {
  const menu = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    menu.current?.querySelector('button:not(:disabled)')?.focus();
    const outside = event => { if (!menu.current?.contains(event.target)) onClose(); };
    document.addEventListener('pointerdown', outside);
    return () => { document.removeEventListener('pointerdown', outside); if (previous?.isConnected) previous.focus({ preventScroll: true }); };
  }, [onClose]);
  if (!found) return null;
  const { clip, track, asset } = found;
  const audio = asset?.has_audio || asset?.kind === 'audio';
  const replacements = project.assets.filter(item => item.id !== asset?.id && compatibleTrack(track, item));
  const command = (action, payload) => { onAction(action, payload); onClose(); };
  const actions = [
    ['split', 'Dividir', Scissors, track.locked || time <= clip.start || time >= clip.start + clip.duration],
    ['duplicate', 'Duplicar', CopyPlus, track.locked], ['copy', 'Copiar', Copy, false], ['paste', 'Pegar', Copy, !canPaste || track.locked],
    ['delete', 'Eliminar clip', Trash2, track.locked], ['ripple', 'Eliminar y cerrar hueco', Trash2, track.locked],
    ...(audio ? [['mute', clip.muted ? 'Activar audio del clip' : 'Silenciar audio del clip', VolumeX, track.locked]] : []),
    ...(asset?.kind === 'video' && asset.has_audio && track.type !== 'audio' ? [['detach', 'Separar audio', Unlink, track.locked || project.tracks.length >= 16]] : []),
    ['properties', 'Propiedades', Settings2, false],
  ];
  return createPortal(<div ref={menu} role="menu" aria-label="Acciones de clip" className="creator-floating-menu creator-clip-menu"
    style={{ left: Math.max(8, Math.min(context.x, window.innerWidth - 228)), top: Math.max(8, Math.min(context.y, window.innerHeight - 400)) }}
    onKeyDown={event => {
      event.stopPropagation();
      if (event.key === 'Escape') { event.preventDefault(); onClose(); }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key) || event.target.tagName === 'SELECT') return;
      event.preventDefault(); const buttons = [...menu.current.querySelectorAll('button:not(:disabled),select:not(:disabled)')];
      const index = buttons.indexOf(document.activeElement);
      buttons[event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length]?.focus();
    }}>
    {actions.map(([action, label, Icon, disabled]) => <button type="button" key={action} role="menuitem" disabled={disabled} onClick={() => command(action)}><Icon size={14} />{label}</button>)}
    {asset && <label>Reemplazar fuente<select aria-label="Reemplazar fuente del clip" value="" disabled={track.locked || !replacements.length} onChange={event => command('replace', event.target.value)}><option value="">Seleccionar medio</option>{replacements.map(item => <option key={item.id} value={item.id}>{item.filename}</option>)}</select></label>}
    <button type="button" role="menuitem" onClick={onClose}><X size={14} />Cerrar</button>
  </div>, document.body);
}
